// Third-party imports
import $ from 'jquery';

// Local imports

import * as constant from '../global/constant.js';
import * as currency from '../util/currency.js';

class SponsorshipCard {
    constructor(global, child, lang) {
        let dataDiv = $('.sponsorship-data');
        let minAmount =
            child.min_amount || $('body').data('minMonthlySponsorship');
        this.minamount = currency.format(minAmount);
        this.labelGender = dataDiv.data('label_gnd');
        this.labelM = dataDiv.data('label_m');
        this.labelF = dataDiv.data('label_f');
        this.labelCountry = dataDiv.data('label_ctry');
        this.labelBD = dataDiv.data('label_bd');
        this.labelYears = dataDiv.data('label_years');
        this.labelYear = dataDiv.data('label_year');
        this.labelMonths = dataDiv.data('label_months');
        this.labelMonth = dataDiv.data('label_month');
        this.labelDays = dataDiv.data('label_days');
        this.labelLearnMore = dataDiv.data('learnmore_link');
        this.labelButton = dataDiv.data('spon_btn');
        this.inCartLabelButton = dataDiv.data('in_cart_spon_btn');
        this.longestWaitingLabel = dataDiv.data('longestwaiting-label');
        this.getChildsAge = getAge(child);
        this.child = child;
        this.language = lang;
        this.global = global;
        this.isInCart =
            global.document.getElementById(`cart_child_id_${child.childid}`) !==
            null;
    }

    build_template() {
        return this.mklink_regional();
    }

    // 0
    mklink_regional() {
        // let template = `
        //     <a href="#sponsorPage-regionalContent"
        let template = `
            <div
                    class="sponsorshipCard smoothScroll--disabled"
                    id="child_card_${this.child.childid}"
                    data-variant-id="${this.child.variant_id}"
                    data-link="${this.child.page_link}"
                    data-price="${this.child.price}"
                    data-img="${this.child.image_sm}"
                    data-min-amount="${this.minamount}"
                    data-lang="${this.child.lang}"
                    data-name="${this.child.name}"
                    data-age="${this.getChildsAge.childsAge}"
                    data-gender="${this.child.gender}"
                    data-country="${this.child.country}"
                    data-subject="${this.child.favorite_subject}"
                    data-play="${this.child.favorite_play}"
                    data-sku="${this.child.sku}"
                    data-product-id="${this.child.product_id}"
                    data-child-id="${this.child.childid}"
                    data-bio="${this.child.content}"
                    data-birth-year="${this.child.birthday_year}"
                    data-birth-month="${this.child.birthday_month}"
                    data-birth-date="${this.child.birthday_day}"
                    data-is-in-cart="${this.isInCart}"
                    data-projectid="${this.child.projectid}"
                    data-childnumber="${this.child.childnumber}"
                    data-firstname="${this.child.firstname}">
        `;

        template += this.mkdiv_inner();

        template += `
            <div class="sponsorshipCard-close"></div>
        `;

        // Close link tag
        template += `
            </div>
        `;

        return template;
    }

    // 1.0
    mkdiv_imagewrapper() {
        let template = `
            <div class="sponsorshipCard-imageWrapper">
                <div class="sponsorshipCard-image"
                     style="background-image: url(${this.child.image});"
                     role="img"
                     aria-label="Photo of ${this.child.name}">
        `;
        template += this.mksvg_childvideo();

        // This closes sponsorshipCard-image and sponsorshipCard-imageWrapper
        template += `
                </div>
            </div>
        `;

        return template;
    }

    // 1.0.0
    mksvg_childvideo() {
        let video_link = this.child.video_link;
        let has_video_link = Boolean(video_link);
        if (!has_video_link) {
            return '';
        }

        let template = `
            <svg class="sponsorshipCard-videoLink" data-video="${video_link}">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--video-camera"></use>
            </svg>
        `;

        return template;
    }

    mkdiv_closebutton() {
        let template = `
            <div class="sponsorshipCard-close"></div>
        `;

        return template;
    }

    // 1
    mkdiv_inner() {
        let template = `
            <div class="sponsorshipCard-inner">
                ${this.mkdiv_closebutton()}
                ${this.mkdiv_imagewrapper()}
                <div class="sponsorshipCard-info-flex-container">
                    ${this.mkdiv_iconinfo()}
                    <div>
                        ${this.mkdiv_button()}
                        ${this.mkdiv_link_learnmore()}
                    </div>
                </div>
            </div>
        `;

        return template;
    }

    mkh3_childname() {
        let template = `
              <h2 class="sponsorshipCard-name">${this.child.name}</h2>
        `;
        return template;
    }

    mkdiv_longestWaiting() {
        let visibility = this.child.longest_waiting
            ? 'visibility:visible'
            : 'visibility:hidden';
        let template = `
            <div class="iconInfoBlock" style="text-align: center; ${visibility}">
                <div class="longestWaitingCardLabel">
                    ${this.longestWaitingLabel}
                </div>
            </div>
        `;
        return template;
    }

    mkdiv_iconinfo() {
        let template = `
            <div class="sponsorshipCard-iconInfoBlockWrap">
                ${this.mkh3_childname()}
                ${this.mkdiv_longestWaiting()}
                ${this.mkdiv_gender()}
                ${this.mkdiv_country()}
                ${this.mkdiv_child_birthday()}
            </div>
        `;
        return template;
    }

    mkdiv_button() {
        let buttonDisabled = this.isInCart ? 'button--disabled' : '';
        let buttonLabel = this.isInCart
            ? this.inCartLabelButton
            : this.labelButton;
        let template = `
            <button
                class="button button--small tocart-btn ${buttonDisabled}"
                id="card_add_button_${this.child.childid}">
                ${buttonLabel}
            </button>
        `;

        return template;
    }

    // This "link does nothing" because clicking the entire card opens the info form
    mkdiv_link_learnmore() {
        let template = `
            <div class="sponsorshipCard-link" role="button" aria-expanded="false" tabindex="0">
                ${this.labelLearnMore}
            </div>
        `;

        return template;
    }

    mkdiv_gender() {
        let display = this.child.gender === 'M' ? this.labelM : this.labelF;
        let template = `
            <div class="iconInfoBlock">
                <svg class="iconInfoBlock-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--boy"></use>
                </svg>
                <dl>
                    <dt class="iconInfoBlock-category">${this.labelGender}</dt>
                    <dd class="iconInfoBlock-info sponsorshipCard-gender">${display}</dd>
                </dl>
            </div>
        `;
        return template;
    }

    mkdiv_country() {
        let template = `
            <div class="iconInfoBlock">
                <svg class="iconInfoBlock-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--globe"></use>
                </svg>
                <dl>
                    <dt class="iconInfoBlock-category">${this.labelCountry}</dt>
                    <dd class="iconInfoBlock-info sponsorshipCard-country">
                        ${this.child.country}
                    </dd>
                </dl>
            </div>
        `;

        return template;
    }

    _build_child_age() {
        let getChildsAge = this.getChildsAge;
        let childage = `${getChildsAge.childsAge} `;
        if (getChildsAge.ageType === 'days') {
            childage += `${this.labelDays}`;
        } else if (getChildsAge.ageType === 'month') {
            childage += `${this.labelMonth}`;
        } else if (getChildsAge.ageType === 'months') {
            childage += `${this.labelMonths}`;
        } else if (getChildsAge.ageType === 'year') {
            childage += `${this.labelYear}`;
        } else {
            childage += `${this.labelYears}`;
        }
        return childage;
    }

    mkdiv_child_birthday() {
        let months = constant.get_months(this.global);
        let child = this.child;

        let birthday_month = child.birthday_month;
        let birthday_day = child.birthday_day;
        let birthday_year = child.birthday_year;
        let birthday_display;
        if (this.language === 'fr') {
            birthday_display = `
                ${birthday_day} ${months[birthday_month]} ${birthday_year}
            `.trim();
        } else if (this.language === 'zh') {
            birthday_display = `
                ${birthday_year}年 ${months[birthday_month]} ${birthday_day}日 
            `.trim();
        } else {
            birthday_display = `
                ${months[birthday_month]} ${birthday_day}, ${birthday_year}
            `.trim();
        }

        let childage = this._build_child_age();

        let template = `
            <div class="iconInfoBlock">
                <svg class="iconInfoBlock-icon">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon--birthday"></use>
                </svg>
                <dl>
                    <dt class="iconInfoBlock-category">${this.labelBD}</dt>
                    <dd class="iconInfoBlock-info sponsorshipCard-birthday">
                        ${birthday_display}<br>
                        <span class="iconInfoBlock-info--em">
                            ${childage}
                        </span>
                    </dd>
                </dl>
            </div>
        `;

        return template;
    }
}

function card_nochild() {
    let template = `
        <div class="sponsorshipCard">
            <div class="sponsorshipCard-inner sponsorshipCard--loading">
                <div class="sponsorshipCard-imageWrapper">
                    <div class="sponsorshipCard-image" style="background-image: url();" role="img"></div>
                </div>
                <div class="spinner spinner--grey"></div>
            </div>
        </div>
    `;

    return template;
}

export function build(global, child) {
    if (!child) {
        return card_nochild();
    }

    let lang = global.document.querySelector('body').dataset.lang;
    let builder = new SponsorshipCard(global, child, lang);
    let ret = builder.build_template();
    return ret;
}

function getAge(child) {
    const MS_PER_YEAR = 1000 * 60 * 60 * 24 * 365;
    const APPROX_MS_PER_MONTH = MS_PER_YEAR / 12;
    const APPROX_MS_PER_DAY = APPROX_MS_PER_MONTH / 30;

    let todayInMS = Date.now();

    // puts month in zero base for JS calculation
    let birthMonth = child.birthday_month - 1;
    let childsAgeInMS = Date.UTC(
        child.birthday_year,
        birthMonth,
        child.birthday_day,
        0,
        0,
        0,
        0
    );

    // Age in 'years old'
    let childsAge = Math.floor((todayInMS - childsAgeInMS) / MS_PER_YEAR);
    let ageType = 'years';

    if (childsAge === 1) {
        ageType = 'year';
    } else if (childsAge < 1) {
        // Approx 'months old'
        childsAge = Math.floor(
            (todayInMS - childsAgeInMS) / APPROX_MS_PER_MONTH
        );
        ageType = 'months';

        if (childsAge === 1) {
            ageType = 'month';
        } else if (childsAge < 1) {
            // Approx 'days old'
            childsAge = Math.floor(
                (todayInMS - childsAgeInMS) / APPROX_MS_PER_DAY
            );
            ageType = 'days';
        }
    }

    let ret = {
        childsAge: childsAge,
        ageType: ageType,
    };

    return ret;
}
